// extracted by mini-css-extract-plugin
export var spotifyEmbedPlayer = "spotify-player-module--spotifyEmbedPlayer--9cbe2";